import { get } from 'lodash';
import { LAYOUT_TYPE_CLASSIC } from '../constants/layout-types';
import { LAYOUT_TYPE_PATH, LAYOUT_TYPE_MAIN_PAGE_PATH } from '../constants/wix-params';
import { getAppSettings } from '../../common/store/app-settings/app-settings-selectors';

export const getLayoutTypeDefault = () => LAYOUT_TYPE_CLASSIC;

export const getLayoutType = state =>
  get(getAppSettings(state), LAYOUT_TYPE_PATH, LAYOUT_TYPE_CLASSIC);

export const getMainPageLayoutType = state =>
  get(getAppSettings(state), LAYOUT_TYPE_MAIN_PAGE_PATH, getLayoutType(state));
